
import { api_host,api_auth} from '../../common/globals/constants';

export const getDetalleDisponibilidadGlobalObjetivo = (objetivo_id, node, period, token) => 
fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadGlobalObjetivo/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&t=${period}&nodoId=${node}`)
.then(response => response.json())
